import { FC } from "react";
import React from "react";
import { useMemo } from "react";
import { FormRenderProps } from "react-final-form";
import { Field } from "react-final-form";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { getData } from "country-list";
import BootstrapInput from "../../../components/BootstrapInput";
import Autocomplete from "../../../components/Autocomplete";
import DatePicker from "../../../components/DatePicker";
import Loading from "../../../components/Loading";
import { AdapterButton } from "../../../components/Adopter";
import Button from "../../../components/Button";
import { Routes } from "../../../constants/routes";

const useStyles = makeStyles((theme: Theme) => ({
  formRoot: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  fieldsContainer: {
    marginBottom: theme.spacing(3),
  },
  addMajorButton: {
    marginRight: theme.spacing(3),
  },
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
}));

const StudentForm: FC<FormRenderProps> = ({
  initialValues,
  handleSubmit,
  submitError,
  submitErrors,
  submitting,
  ...props
}) => {
  const classes = useStyles();
  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );

  return (
    <form noValidate onSubmit={handleSubmit}>
      {submitError && <Typography color="error">{submitError}</Typography>}
      {submitting && <Loading />}
      <Grid container spacing={3} className={classes.fieldsContainer}>
        <Grid item xs={12} sm={6} md={4}>
          <Field
            required
            fullWidth
            type="text"
            name="name"
            label="Name"
            placeholder="Name"
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Field
            required
            fullWidth
            type="text"
            name="phone"
            label="Phone Number"
            placeholder="+19159969739"
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Field
            required
            autoOk
            fullWidth
            name="studentProfile.birth_date"
            label="Birth Date"
            component={DatePicker}
            placeholder="Birth Date"
            animateYearScrolling
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Field
            required
            fullWidth
            name="studentProfile.country"
            label="Country"
            options={countries}
            placeholder="Country"
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Field
            required
            fullWidth
            type="text"
            name="studentProfile.city"
            label="City"
            placeholder="City"
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Field
            required
            fullWidth
            name="studentProfile.citizenship"
            label="Citizenship"
            options={countries}
            placeholder="Citizenship"
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Field
            required
            fullWidth
            type="text"
            name="email"
            label="Email"
            placeholder="Email"
            component={BootstrapInput}
          />
        </Grid>
      </Grid>

      <Typography align="right" component="div">
        <AdapterButton
          to={`/0/${Routes.USER_STUDENTS}`}
          style={{ marginRight: 20 }}
          color={"default"}
          variant="contained"
          disabled={submitting}
        >
          Back
        </AdapterButton>
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          disabled={submitting}
        >
          Save
        </Button>
      </Typography>
    </form>
  );
};

export default StudentForm;
